import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>Footer</p>
      {/* Footer content will go here */}
    </footer>
  );
};

export default Footer;
